<template>
  <section class="osk-home-blocks-footer-buttons">
    <div class="osk-wrapper">
      <UikitButton
        v-for="(button, index) in buttons"
        :key="index"
        :class="{
          'osk-home-blocks-footer-buttons__button': true,
          'osk-home-blocks-footer-buttons__button_share': button.type === 'SHARE',
          'osk-home-blocks-footer-buttons__button_share-hide': button.type === 'SHARE' && !isSupported,
        }"
        size="l"
        full-width
        :color="button.type === 'SHARE' && buttons.length > 1 ? 'secondary' : undefined"
        @click="handleButtonClick(button.link, button.type === 'SHARE')"
      >
        {{ button.title }}
      </UikitButton>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { PrimaryContentDTO, FooterButtonDTO } from '~/restAPI/data-contracts';
import { AnalyticsEvents } from '~/types/analytics';

const props = defineProps<{
  data: PrimaryContentDTO
}>();

const { share, isSupported } = useShare();
const { $addEvent } = useNuxtApp();
const { isConciergeDialogOpen } = useConcierge();

const buttons = computed(() => (props.data.contentList ?? []) as FooterButtonDTO[]);
const analytics = computed(() => ({
  chapter: props.data.contentType,
  chapter_index: props.data.chapterIndex,
  segment_id: props.data.segmentId,
  id_chapter: props.data.id,
}));

async function handleButtonClick(url: string, isShare: boolean) {
  if (isShare && isSupported.value) {
    share({
      title: document.title,
      url: window.location.href,
    }).catch((err) => err);

    $addEvent(AnalyticsEvents.ClickEvent, {
      ...analytics.value,
      item: 'details',
      action: 'share_down',
    });

    return;
  }

  $addEvent(AnalyticsEvents.ClickEvent, {
    ...analytics.value,
    item: 'details',
    action: 'shop',
  });

  const link = genSPALink(url);

  if (!link) return;

  if (link.includes('concierge_form')) {
    isConciergeDialogOpen.value = true;
    return;
  }

  const external = !link.startsWith('/') || link.startsWith('//');

  await navigateTo(link, { external });
}
</script>

<style lang="scss">
@import "~/assets/scss/settings/index";

.osk-home-blocks-footer-buttons {
  @include media-query(md-and-up) {
    display: none;
  }

  &__button {
    margin-bottom: $indent-medium;

    &_share-hide {
      display: none;
    }
  }
}

.osk-home-gender-page_isJournalMode {
  .osk-blocks-text-controls_full + .osk-home-blocks-footer-buttons {
    margin-top: -8px;

    @include media-query(lg-and-up) {
      margin-top: 0;
    }
  }
}
</style>
